import { render, staticRenderFns } from "./FileLibraryList.vue?vue&type=template&id=3c45a8d2&scoped=true&"
import script from "./FileLibraryList.vue?vue&type=script&lang=js&"
export * from "./FileLibraryList.vue?vue&type=script&lang=js&"
import style0 from "./FileLibraryList.vue?vue&type=style&index=0&id=3c45a8d2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c45a8d2",
  null
  
)

export default component.exports